<template>
    <div class="com-item txt-info-module" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" :style="{
                backgroundColor: modata.WContent.bgColor || 'transparent'
            }">
                <div class="txt-info-module__inner" :style="{
                    padding: '0 ' + (modata.WContent.moduleSpac || 0) + 'px',
                    color: modata.WContent.textColor || '#333'
                }">
                    <div class="txt-info-module__left">
                        <p class="txt-info-module__title">{{ modata.WContent.cnTitle }}</p>
                        <p class="txt-info-module__subtitle">{{ modata.WContent.enTitle }}</p>
                    </div>
                    <div class="txt-info-module__right ql-editor">
                        <div v-html="modata.WContent.textHtml"></div>
                    </div>
                </div>
                <div class="txt-info-module__image" v-if="modata.WContent.imgUrl">
                    <img :src="modata.WContent.imgUrl" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "txt-info-module",
    components: {},
    props: {
        index: {
            type: Number
        },
        type: {
            type: String,
            default: 'preview'
        },
        isactive: {
            type: Boolean,
            default: false
        },
        phoneWidth: {
            type: Number,
            default: 1280
        },
        proportion: {
            type: Number,
            default: 1
        },
        modata: {
            type: Object,
            default: function() {
                return {
                    WName: 'txt-info',
                    Title: '文本介绍模块',
                    MID: 12,
                    WID: null,
                    ModuleName: 'txt-info-module',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {}
    },
    mounted() {},
    beforeDestroy() {},
    methods: {},
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
p {
    margin: 0;
}
.txt-info-module {
    min-height: 300px;
    padding-top: 5%;
    padding-bottom: 0;
    position: relative;

    .txt-info-module__inner {
        width: 90%;
        max-width: 1600px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;
    }

    .txt-info-module__left {
        flex: 0 0 40%;
        max-width: 40%;
        margin-right: 5%;
        padding-right: 0;
        box-sizing: border-box;
    }

    .txt-info-module__title {
        font-size: 42px;
        font-family: "pingfang heavy", "PingFang SC", "Microsoft YaHei", sans-serif;
        line-height: 1.2;
        margin: 0;
        word-break: break-word;
    }

    .txt-info-module__subtitle {
        font-size: 22px;
        line-height: 1.2;
        margin: 10px 0 0 0;
        word-break: break-word;
    }

    .txt-info-module__right {
        flex: 1;
        min-width: 0;
        font-size: 15px;
        line-height: 1.8;
        text-align: justify;
        color: inherit;
        align-self: center;
        margin-top: 20px;
        max-height: 300px;
        overflow-y: auto;
        text-indent: 2em;
        padding-right: 30px;

        &::-webkit-scrollbar {
            width: 5px;
            height: 1px;
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            background: #2e5db5;
        }
        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            background: #ffffff;
        }
    }

    .txt-info-module__image {
        overflow: hidden;
        max-width: 755px;
        width: 45%;
        margin: 2% 0 0;

        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
        }
    }
}
@media screen and (max-width: 768px) {
    .txt-info-module {
        padding-top: 40px;

        .txt-info-module__inner {
            flex-direction: column;
        }
        .txt-info-module__left {
            flex: 0 0 100%;
            max-width: 100%;
            margin-right: 0;
        }
        .txt-info-module__title {
            font-size: 28px;
            line-height: 1;
        }
        .txt-info-module__subtitle {
            font-size: 18px;
            line-height: 1.2;
            margin-top: 10px;
        }
        .txt-info-module__right {
            width: auto;
            max-width: none;
            height: auto;
            max-height: none;
            line-height: 1.8;
        }
        .txt-info-module__image {
            width: 90%;
        }
    }
}
</style>
<style>
.txt-info-module__right p {
    margin: 0;
}
</style>
